import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';
import CheckedItemDTO from '@/Communication/CheckedItemDTO';

export default class CheckedItemsDTO extends DataTransferObject {

    public Items: Array<CheckedItemDTO>;

    public constructor() {
        super({ xmlProperties: ['Items'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.Items = this.defaultFromType('array');
    }
}

ComponentManager.setModel('CheckedItemsDTO', CheckedItemsDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');